import api from "./instance";

export const getMyBookings = () => api.get("/staff/mybookings");

export const getRecentDoctorBooking = () =>
  api.get("/staff/recent-doctor-booking");

export const getRecentPackageBooking = () =>
  api.get("/staff/recent-package-booking");

export const cancelBooking = (_staffId, bookingId, payload) =>
  api.put("/staff/cancel-booking", { bookingId, ...payload });

export const rescheduleBooking = (_staffId, bookingId, payload) =>
  api.put("/staff/reschedulebooking", { bookingId, ...payload });

export const diagReschedule = (_staffId, bookingId, payload) =>
  api.put("/staff/diagreschedule", { bookingId, ...payload });

export const packageReschedule = (_staffId, bookingId, payload) =>
  api.put("/staff/packagereschedule", { bookingId, ...payload });

export const downloadBookingReport = (bookingId) =>
  api.get("/staff/download-report", {
    data: { bookingId },
    responseType: "blob",
  });

export const createConsultationBooking = (_staffId, payload) =>
  api.post("/staff/consultationbooking/", payload);

export const createPackageBooking = (_staffId, payload) =>
  api.post("/staff/package-bookings", payload);

export const createDiagnosticBookings = (_staffId, payload) =>
  api.post("/staff/create-bookings", payload);

export const getDoctorAppointments = (status) =>
  api.get("/staff/getdoctorappointment", status ? { data: { status } } : {});

export const getPrescriptions = (status) =>
  api.get("/staff/getPrescription", status ? { data: { status } } : {});

export const bookAppointment = (payload) => api.post("/staff/bookappoint", payload);

export const getAppointment = (appointmentId) =>
  api.get("/staff/getappoint", { data: { appointmentId } });

export const processPayment = (appointmentId) =>
  api.post("/staff/process-payment", { appointmentId });
